var _style, _path, _path2, _path3, _g, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n\t.st3{fill:#FF9811;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.7,486.6C178.4,502.9,216.1,512,256,512s77.6-9.1,111.3-25.4L389.6,256L367.3,25.4C333.6,9.1,295.9,0,256,0 s-77.6,9.1-111.3,25.4L122.4,256L144.7,486.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,486.6C452.9,445.2,512,357.5,512,256S452.9,66.8,367.3,25.4L367.3,486.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.7,486.6V25.4C59.1,66.8,0,154.5,0,256S59.1,445.2,144.7,486.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,345c0-40.9,0-89,0-89h66.8v33.4c0,5.8-11.1,27.1-38.6,44.5C273.8,340.5,263,342.7,256,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.2,189.2H256V256h-66.8L189.2,189.2z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.4,167c0-12.3-10-22.3-22.3-22.3c-4.1,0-7.9,1.1-11.1,3c-3.3-1.9-7.1-3-11.1-3c-12.3,0-22.3,10-22.3,22.3 H167v111.3c0,41.4,32.9,65.4,58.7,77.8c-1.9,3.3-3.1,7.1-3.1,11.2c0,12.3,10,22.3,22.3,22.3c4.1,0,7.9-1.1,11.1-3 c3.3,1.9,7.1,3,11.1,3c12.3,0,22.3-10,22.3-22.3c0-4.1-1.1-7.9-3.1-11.2c25.8-12.4,58.7-36.4,58.7-77.8V167H289.4z M311.7,278.3 c0,5.8,0,23.5-27.5,40.9c-10.4,6.6-21.2,10.9-28.2,13.3c-7-2.4-17.8-6.7-28.2-13.3c-27.5-17.5-27.5-35.1-27.5-40.9v-77.9h111.3 L311.7,278.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.843f4dbca7575fa36831d541fc3f0cc2.svg";
export { ForwardRef as ReactComponent };